import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import styled from "styled-components";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ZStatsChartContainer = styled.div`
  width: 500px;
  height: 300px;
  @media (max-width: 600px) {
    width: 100%;
    height: 200px;
  }
`;
export default function ZMaxMinBars({ beforeStats, afterStats }) {
  const beforeMax = beforeStats.maxZ ? beforeStats.maxZ : 0;
  const beforeMin = beforeStats.minZ ? beforeStats.minZ : 0;
  const afterMax = afterStats.maxZ ? afterStats.maxZ : 0;
  const afterMin = afterStats.minZ ? afterStats.minZ : 0;

  const calculateYAxisRange = (beforeStats, afterStats) => {
    const allMinZ = Math.min(beforeStats.minZ, afterStats.minZ);
    const allMaxZ = Math.max(beforeStats.maxZ, afterStats.maxZ);

    const range = allMaxZ - allMinZ;
    const padding = range * 0.1; // 10% 여백

    return {
      min: allMinZ - padding,
      max: allMaxZ + padding,
    };
  };

  // options에서 사용
  const yAxisRange = calculateYAxisRange(beforeStats, afterStats);

  const data = {
    labels: ["보정 전 Max", "보정 전 Min", "보정 후 Max", "보정 후 Min"],
    datasets: [
      {
        label: "Z 값",
        data: [beforeMax, beforeMin, afterMax, afterMin],
        backgroundColor: ["rgba(255, 99, 132, 0.7)", "rgba(54, 162, 235, 0.7)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
        barThickness: 60,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "Z축 최대/최소 비교 (보정 전후)",
        font: {
          size: 15,
          weight: "500",
        },
        color: "white",
      },
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${ctx.parsed.y.toFixed(2)}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: false,
        min: yAxisRange.min,
        max: yAxisRange.max,
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
        ticks: {
          color: "white",
          stepSize: 0.5, // 0.5 단위 눈금
          callback: function (value) {
            return value.toFixed(1);
          },
        },
      },
      x: {
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
        ticks: {
          color: "white",
        },
      },
    },
  };

  return (
    <ZStatsChartContainer>
      <Bar data={data} options={options} />
    </ZStatsChartContainer>
  );
}
